<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          :showAddNew="false"
          title="Reward Import List"
      >
        <template #extra-btn>
          <a
              download
              href="/file/import-reward-point-list.xlsx"
              class="btn btn-outline-secondary waves-effect waves-float waves-light"
          >Download Sample</a>
        </template>
      </TitleButton>
      <input type="file" class="d-none" ref="uploader" @change="handleFileUpload">
    </div>

    <div class="row p-2">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <label class="col-form-label">Reward Point Expense Account (P&L)</label>
        <AsyncSelect
            placeholder="Select Account Head"
            :api-service="fetchAccountHeadsList"
            :reduce="(name) => name.id"
            v-model="accountHeadId"
            :additional-query="{cash_bank_hide: 'yes', status: 'active'}"
            :format-label="formatPatientLabel"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <label class="col-form-label">Reward Point Liability Account</label>
        <v-select
            placeholder="Select Liability Head"
            :options="rewardPointAcc"
            :reduce="(name) => name.id"
            v-model="liabilityHeadId"
            label="name"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <label class="col-form-label">Adjustment Date</label>
        <input type="date" class="form-control" v-model="adjustmentDate">
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
        <button @click="onClickBrowse" class="btn btn-primary waves-effect waves-float waves-light">
          Browse
        </button>
      </div>
    </div>

    <div class="p-2">
      <div v-for="(item, index) in csvRow" :key="index">
        <div @click="goToUpload(item.id)" class="py-1 bg-black-light rounded-8 mb-2 d-flex justify-content-between align-items-center cursor-pointer">
          <span class="px-1">id: {{ item.id }} Dataset: {{ item.batch }}</span>
          <div class="d-flex gap-1 px-1">
            <span class="cursor-pointer text-danger" @click.stop="deleteRow(item.id)"><i class="fas fa-trash"></i></span>
          </div>
        </div>
      </div>
    </div>

    <GlobalLoader/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue'
import GlobalLoader from '@/components/atom/GlobalLoader.vue'
import AsyncSelect from '@/components/molecule/input-field/AsyncSelect.vue'
import {inject, onMounted, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import handleInventory from '@/services/modules/inventory'
import handlePurchase from '@/services/modules/purchase'
import handleJournal from '@/services/modules/journal'
import {useAsyncDropdownHelper} from '@/services/utils/asyncDropdownHelper'

const route = useRoute()
const router = useRouter()
const showError = inject('showError')
const showSuccess = inject('showSuccess')

const {uploadRewardPointCsvFile, fetchCsvRow, deleteCsvRow} = handleInventory()
const {formatPatientLabel} = useAsyncDropdownHelper()
const {getAccountHeadBySlag} = handlePurchase()
const {fetchAccountHeadsList} = handleJournal()

const uploader = ref(null)
const csvRow = ref([])
const rewardPointAcc = ref([])
const liabilityHeadId = ref(null)
const accountHeadId = ref(null)
const adjustmentDate = ref(null)

const getQuery = () => {
  return `?company_id=${route.params.companyId}`
}

const goToUpload = (id) => {
  const query = Object.assign({}, route.query)
  query.rowId = id
  router.push({name: 'upload-reward-point', params: route.params, query})
}

const getCsvRow = () => {
  const query = getQuery() + '&type=reward_point'
  fetchCsvRow(query).then((res) => {
    if (!res.status) return
    csvRow.value = res.data
  })
}

const getRewardPointAccounts = () => {
  return getAccountHeadBySlag('reward_points', getQuery()).then((res) => {
    if (!res.status) return
    rewardPointAcc.value = res.data
  })
}

const deleteRow = (id) => {
  if (!confirm('Are you sure you want to delete this row?')) return
  const query = getQuery() + '&type=reward_point'
  deleteCsvRow(query, id).then((res) => {
    if (!res.status) return showError(res.message)
    csvRow.value = []
    getCsvRow()
    showSuccess(res.message)
  })
}

const onClickBrowse = () => {
  if (!accountHeadId.value) return showError('Please select reward point expense account')
  if (!liabilityHeadId.value) return showError('Please select reward point liability account')
  if (!adjustmentDate.value) return showError('Please select adjustment date')
  uploader.value.click()
}

const handleFileUpload = (event) => {
  const fd = new FormData()
  fd.append('company_id', route.params.companyId)
  fd.append('sheet', event.target.files[0])
  fd.append('account_head_id', accountHeadId.value)
  fd.append('liability_head_id', liabilityHeadId.value)
  fd.append('date', adjustmentDate.value)

  uploadRewardPointCsvFile(fd).then((res) => {
    if (!res.status) return showError(res.message)
    showSuccess(res.message)
    getCsvRow()
  }).finally(() => {
    uploader.value.value = ''
  })
}

onMounted(() => {
  adjustmentDate.value = new Date().toISOString().split('T')[0]
  getRewardPointAccounts()
  getCsvRow()
})
</script>
